import React from 'react'
import { Text } from '@chakra-ui/react'

import { ListGroupItem } from 'components'

export const QuestionListGroupItem = React.forwardRef(({ question, children, ...props }, ref) => (
  <ListGroupItem {...props} ref={ref}>
    <Text noOfLines={1}>
      {question.text} {question?.dimension?.name}
    </Text>
    {children}
  </ListGroupItem>
))

export default QuestionListGroupItem
